/**
 * @package {COMPONENT NAME}
 *
 * Entry point for Javascript package
 */

// @ts-ignore
import Cookies from 'js-cookie';

// Get cookie container and button
const cookieContainer = <HTMLDivElement>document.getElementById('gdpr-notice-wrapper');
const cookieButton = <HTMLButtonElement>document.getElementById('gdpr-notice-accept');

// Set cookie name
const cookieName = 'soulgood_gdpr_data';

// When user clicks the button
// Set consent for a year and remove the container
function handleCookie() {
  // Get checkboxes
  const checkboxes = {
    google: <HTMLInputElement>document.getElementById('google_tracker_gdrp_checkbox'),
    facebook: <HTMLInputElement>document.getElementById('facebook_tracker_gdrp_checkbox'),
    misc: <HTMLInputElement>document.getElementById('misc_tracker_gdrp_checkbox'),
  };

  // Check checkbox status
  const accepted = {
    google_analytics_code: checkboxes.google?.checked,
    facebook_tracking_code: checkboxes.facebook?.checked,
    misc_tracking_code: checkboxes.misc?.checked,
  };

  // Stringify the data
  const cookieData = JSON.stringify(accepted);

  // Set cookie
  Cookies.set(cookieName, cookieData, {
    expires: 365,
  });

  // Remove all not accepted scripts
  for (const value in accepted) {
    if (!accepted[value]) {
      const scriptTag = document.querySelector(`#${value}`);
      scriptTag?.remove();
    }
  }

  // Remove the cookie container
  cookieContainer.remove();
}

function addCheckBoxTriggers() {
  const checkboxWrappers = document.querySelectorAll('.gdpr-notice__option');

  checkboxWrappers.forEach((wrapper: HTMLElement) => {
    const inputele = wrapper.querySelector('input');
    const wrapperele = <HTMLElement>wrapper.querySelector('.gdpr-notice__option-input-wrapper');

    inputele.addEventListener('change', () => {
      wrapperele.dataset.isEnabled = inputele.checked.toString();
    });
  });
}

if (cookieButton) {
  // Check if cookies have been accepted
  if (Cookies.get(cookieName)) {
    cookieContainer.remove();
  }

  // Add event listener to cookie button
  cookieButton.addEventListener('click', handleCookie);

  // Add checkbox triggers
  addCheckBoxTriggers();
}
